module.exports = __webpack_public_path__ + "img/computational.b28b4d31.png";